import { render, staticRenderFns } from "./pedidoSecuencia.vue?vue&type=template&id=31ca7b9d"
import script from "./pedidoSecuencia.vue?vue&type=script&lang=js"
export * from "./pedidoSecuencia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports